import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  GET_SARS_START,
  GET_SARS_SUCCESS,
  GET_SARS_FAILURE,
  ADD_SAR_START,
  ADD_SAR_SUCCESS,
  ADD_SAR_FAILURE,
  ADD_LOAN_START,
  ADD_LOAN_SUCCESS,
  ADD_LOAN_FAILURE,
  UPDATE_LOAN_START,
  UPDATE_LOAN_SUCCESS,
  UPDATE_LOAN_FAILURE,
  DELETE_LOAN_START,
  DELETE_LOAN_SUCCESS,
  DELETE_LOAN_FAILURE,
} from './actions';

export const transformSar = response => {
  return {
    sarId: response.sar_fincen_id,
    sarFilerName: response.sar_filer_name,
    sarFiledDate: response.sar_filed_date,
  };
};

export const transformSars = response => {
  return response.map(s => transformSar(s));
};

// FETCH SARS
const getSarsReducers = createApiReducer(
  [GET_SARS_START, GET_SARS_SUCCESS, GET_SARS_FAILURE],
  (payload, state) => {
    const transformedResponse = transformSars(payload);
    return {
      ...state.data,
      sars: transformedResponse,
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

// ADD SAR
const addSarReducer = createApiReducer(
  [ADD_SAR_START, ADD_SAR_SUCCESS, ADD_SAR_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      sars: [...state.data.sars, transformSar(payload)],
    };
  },
  error => transformSar(_.get(error, 'payload.response', {}))
);

export const transformLoan = response => ({
  id: response.id,
  loanAnnualSales: response.loan_annual_sales,
  loanBuisnessNetIncome: response.loan_buisness_net_income,
  loanBusinessNetEquity: response.loan_business_net_equity,
  loanNumberOfEmployees: response.loan_number_of_employees,
  loanDecApplicantOblig: response.loan_dec_applicant_oblig,
  loanDecApplicantTaxesPastDue: response.loan_dec_applicant_taxes_past_due,
  loanDecApplicantTaxesPastDueAmt:
    response.loan_dec_applicant_taxes_past_due_amt,
  loanDecApplicantTaxesPastDueOwedTo:
    response.loan_dec_applicant_taxes_past_due_owed_to,
  loanDecOtherAssetsPledged: response.loan_dec_other_assets_pledged,
  loanDecOtherCreditPastDue: response.loan_dec_other_credit_past_due,
  loanDecApplicantFelon: response.loan_dec_applicant_felon,
  loanDecApplicantPolitical: response.loan_dec_applicant_political,
  loanDecApplicantPoliticalNameOfEmployee:
    response.loan_dec_applicant_political_name_of_employee,
  loanDecApplicantEmployeeOfBank: response.loan_dec_applicant_employee_of_bank,
  loanDecApplicantEmployeeOfBankEmployee:
    response.loan_dec_applicant_employee_of_bank_employee,
  loanDecApplicantFinInstEmployee:
    response.loan_dec_applicant_fin_inst_employee,
  loanDecApplicantFinInstEmployeeFi:
    response.loan_dec_applicant_fin_inst_employee_fi,
  loanDecWillFiftyComeFromLease: response.loan_dec_will_fifty_come_from_lease,
  loanDecWillFiftyComeFromSale: response.loan_dec_will_fifty_come_from_sale,
  loanIsArchived: response.loan_is_archived,
  loanIsApproved: response.loan_is_approved,
  loanIsDenied: response.loan_is_denied,
  loanSubmittedToFinancialInstitution:
    response.loan_submitted_to_financial_institution,
  loanAddedDate: response.loan_added_date,
  loanAutomaticPaymentChecking: response.loan_automatic_payment_checking,
  loanType: response.loan_type,
  loanAmount: response.loan_amount,
  loanClosedDate: response.loan_closed_date,
  loanIdentifier: response.loan_identifier,
  loanPaymentMethod: response.loan_payment_method,
  loanRepaymentPeriod: response.loan_repayment_period,
  loanUseOfFunds: response.loan_use_of_funds,
  loanPaymentAmount: response.loan_payment_amount,
});

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountAddLoanReducer = createApiReducer(
  [ADD_LOAN_START, ADD_LOAN_SUCCESS, ADD_LOAN_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      loans: [...state.data.loans, transformLoan(payload)],
    };
  },
  error => transformLoan(_.get(error, 'payload.response', {}))
);

const updateLoans = (payload, state) => {
  const newLoan = transformLoan(payload);

  return {
    ...state.data,
    loans: updateItem(state.data.loans, 'id', newLoan.id, newLoan),
  };
};

const accountUpdateLoanReducer = createApiReducer(
  [UPDATE_LOAN_START, UPDATE_LOAN_SUCCESS, UPDATE_LOAN_FAILURE],
  updateLoans,
  error => transformLoan(_.get(error, 'payload.response', {}))
);

const accountDeleteLoanReducer = createApiReducer(
  [DELETE_LOAN_START, DELETE_LOAN_SUCCESS, DELETE_LOAN_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      loans: state.data.loans.filter(l => l.id !== payload.id),
    };
  },
  error => transformLoan(_.get(error, 'payload.response', {}))
);

export const reducers = [
  getSarsReducers,
  addSarReducer,
  accountAddLoanReducer,
  accountUpdateLoanReducer,
  accountDeleteLoanReducer,
];
